<app-media-block contentType="scenic" [mediaForm]="mediaBlockFormGroup" />
<app-information-block contentType="scenic" [informationForm]="informationBlockFormGroup" />
<app-recommendation-block contentType="scenic" [recommendationForm]="recommandationBlockFormGroup" />
<app-publication-block contentType="scenic" [publicationForm]="publicationBlockFormGroup" />